import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		paper: {
			margin: 48,
			maxWidth: 1400,
			width: "calc(100% - 96px)",
			height: "calc(100% - 96px)",
			borderRadius: 8,
			display: "flex",
			flexDirection: "column",
			[theme.breakpoints.down("sm")]: {
				margin: 0,
				width: "100%",
				height: "100%",
				maxWidth: "100%",
				borderRadius: 0,
			},
		},
		header: {
			backgroundColor: theme.palette.background.paper,
			flexShrink: 0,
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			padding: theme.spacing(2, 3),
			borderBottom: `1px solid ${theme.palette.divider}`,
		},
		headerLeft: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
		},
		title: {
			fontWeight: 700,
			fontSize: 24,
			lineHeight: "32px",
			color: "#1C1B1F",
		},
		leadTag: {
			backgroundColor: "#A4D1D7",
			color: "#265257",
			marginLeft: theme.spacing(1),
			"& .MuiChip-icon": {
				color: "#265257",
			},
		},
		content: {
			flex: 1,
			overflowY: "auto",
		},
		contentInner: {
			padding: theme.spacing(3),
		},
		actions: {
			backgroundColor: theme.palette.background.paper,
			flexShrink: 0,
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
			padding: theme.spacing(2, 3),
			borderTop: `1px solid ${theme.palette.divider}`,
			gap: theme.spacing(1),
			[theme.breakpoints.down("sm")]: {
				justifyContent: "stretch",
				"& button": {
					flex: 1,
				},
			},
		},
		backdrop: {
			backgroundColor: "rgba(0, 0, 0, 0.25)",
		},
	} satisfies Record<string, CSSObject>);
};
